import { cloneElement, type ReactElement } from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import type { KNCaptionProps } from './types'

const KNCaption = ({ children, icon, iconColor, fontColor, reversed = false, onClick, sx }: KNCaptionProps): ReactElement => (
  <Stack
    data-test="caption"
    spacing={1}
    direction={reversed ? 'row-reverse' : 'row'}
    alignItems="center"
    sx={{
      cursor: onClick ? 'pointer' : undefined,
      ...sx,
    }}
    onClick={onClick}
  >
    {icon &&
      cloneElement(icon, {
        fontSize: 'small',
        color: iconColor ?? 'primary',
      })}
    {children && (
      <Typography color={fontColor ?? 'primary'} variant="p5">
        {children}
      </Typography>
    )}
  </Stack>
)

export default KNCaption
